import { render, staticRenderFns } from "./TabPanel.vue?vue&type=template&id=4c15ee27&scoped=true"
import script from "./TabPanel.vue?vue&type=script&lang=js"
export * from "./TabPanel.vue?vue&type=script&lang=js"
import style0 from "./TabPanel.vue?vue&type=style&index=0&id=4c15ee27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c15ee27",
  null
  
)

export default component.exports